import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { EntityDisplay } from "@components/entity/EntityDisplay";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import {
    parseRowId,
    type ApplyReportTemplateRow,
} from "../applyReportTemplateRows";

export const ApplyReportTemplateNameCell = memo(
    ({
        row,
        getValue,
    }: CellContext<ViewTableFeatures, ApplyReportTemplateRow, string>) => {
        const item = row.original;
        if (item.isClientRow) {
            return (
                <ViewTableCell>
                    <BreakableText showTooltip text={getValue()} />
                </ViewTableCell>
            );
        }
        const parsedRowId = parseRowId(item.id);
        return (
            <ViewTableCell>
                <EntityDisplay
                    entity={{
                        id:
                            parsedRowId.kind === "entity"
                                ? parsedRowId.entityId
                                : 0,
                        name: item.name,
                        iconColor: item.iconColor,
                        logo: item.logo,
                        isPersonal: false,
                    }}
                />
            </ViewTableCell>
        );
    },
);
